import styled, { css } from 'styled-components';
import { GalleryContainer } from '@anwb/gallery';
import { STATIC_BASE_URL, pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
const TIMELINE_ITEM_MIN_HEIGHT = 40;
const IMAGE_WIDTH = 297;
const LINE_GUTTER = 32;
const LINE_OFFSET_TOP = 24;
const LINE_OFFSET_LEFT = 8;
const ITEM_INDICATOR_SIZE = 18;
const ITEM_INDICATOR_OFFSET_TOP = 3;
/**
 * Timeline container
 */
export const timelineContainerStyle = ({ theme, $isSpacious, }) => css `
	margin: 0;
	padding: 0;
	list-style: none;
	padding-inline-start: 0;

	// sc-@TODO: Use PonchoStructure once it is a styled component and referencable
	.PONCHO-structure {
		margin-top: ${pxToRem(theme.spacing['100'])};
	}

	${$isSpacious &&
    css `
		margin-top: ${pxToRem(theme.spacing['400'])};
	`}
`;
export const TimelineContainer = styled.ol `
	${timelineContainerStyle}
`;
/**
 * Timeline item
 */
export const timelineItemContainerStyles = ({ theme, $isChecked, $isInactive, }) => css `
	position: relative;
	padding-left: ${pxToRem(LINE_GUTTER)};
	min-height: ${pxToRem(TIMELINE_ITEM_MIN_HEIGHT)};
	padding-bottom: ${pxToRem(theme.spacing['400'])};
	overflow: hidden;

	&::before {
		content: '';
		position: absolute;
		width: ${pxToRem(theme.borderWidth['2'])};
		background-color: ${theme.colors.informative.timelineElement};
		left: ${pxToRem(LINE_OFFSET_LEFT)};
		top: ${pxToRem(LINE_OFFSET_TOP)};
		bottom: 0;
		${$isInactive &&
    css `
			background-color: ${theme.colors.medium.timelineElementInactive};
		`}
	}

	&::after {
		content: '';
		position: absolute;
		width: ${pxToRem(ITEM_INDICATOR_SIZE)};
		height: ${pxToRem(ITEM_INDICATOR_SIZE)};
		top: ${pxToRem(ITEM_INDICATOR_OFFSET_TOP)};
		left: 0;

		background-color: ${theme.colors.informative.timelineElement};
		border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.informative.timelineElement};
		border-radius: ${theme.borderRadius.rounded}%;
		box-shadow: 0 0 0 ${pxToRem(theme.borderWidth['2'])} ${theme.colors.blanc.bgSite} inset;
		${$isInactive &&
    css `
			background-color: ${theme.colors.medium.timelineElementInactive};
			border: ${pxToRem(theme.borderWidth['2'])} solid
				${theme.colors.medium.timelineElementInactive};
		`}
	}

	&:last-child:not(:only-child)::before {
		width: 0;
	}

	&:last-child {
		padding-bottom: 0;
	}

	${$isChecked &&
    css `
		&::after {
			border: none;
			border-radius: 0;
			box-shadow: none;
			background-color: transparent;
			background-repeat: no-repeat;
			background-position: 50% 50%;
			background-image: url(${`${STATIC_BASE_URL}/poncho/timeline/images/checked.svg`});
		}
	`}
`;
export const TimelineItemContainer = styled.li `
	${timelineItemContainerStyles}
`;
/**
 * Timeline timestamp
 */
export const timelineTimestampStyles = ({ theme, $isInactive, }) => css `
	margin: 0;
	margin-bottom: ${pxToRem(theme.spacing['100'])};
	color: ${theme.colors.informative.textSupport};
	${$isInactive &&
    css `
		opacity: 0.3;
	`}
`;
export const TimelineTimestamp = styled(Typography).attrs({ variant: 'label-title' }) `
	${timelineTimestampStyles}
`;
/**
 * Timeline title
 */
export const timelineTitleStyles = ({ theme, $isInactive, }) => css `
	margin: 0;
	margin-bottom: ${pxToRem(theme.spacing['100'])};
	${$isInactive &&
    css `
		opacity: 0.3;
	`}
`;
export const TimelineTitle = styled(Typography).attrs({ variant: 'content-title' }) `
	${timelineTitleStyles}
`;
/**
 * Timeline content
 */
export const timelineContentStyles = ({ $isInactive }) => css `
	p:first-child {
		margin-top: 0;
	}

	p:last-child {
		margin-bottom: 0;
	}

	${$isInactive &&
    css `
		opacity: 0.3;
	`}
`;
export const TimelineContent = styled(Typography).attrs({
    variant: 'body-text',
    tagName: 'div',
}) `
	${timelineContentStyles}
`;
export const timelineVisualContainerStyles = ({ theme, $isTwoColumns = false, }) => css `
	margin-top: 0;
	width: 100%;

	> * {
		margin-top: 0;
	}

	&:not(${GalleryContainer}) {
		display: block;
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		margin-right: ${pxToRem(theme.spacing['300'])};
		width: ${pxToRem(IMAGE_WIDTH)};
	}

	${$isTwoColumns &&
    css `
		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			width: 100%;
			height: auto;
		}

		margin-top: ${pxToRem(theme.spacing['100'])};
	`}
`;
export const TimelineVisualContainer = styled.div `
	${timelineVisualContainerStyles}
`;
//# sourceMappingURL=timeline.styled.js.map